import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query AppLandingQuery($id: ID!, $hurray: Boolean!) {
        learningPath(id: $id) {
            id
            pathname
            info
            avatarSrc(hurray: $hurray)
            goal
            appRatingConfig
            showRatingAfterTasks
            showParticipants
            pathGroup {
                id
                name
                number
                members {
                    id
                    person {
                        id
                        firstName
                        lastName
                        profilePicSrc
                    }
                }
            }
            learningCoaches {
                id
                firstName
                lastName
                profilePicSrc
            }
            participants {
                id
                firstName
                lastName
                profilePicSrc
            }
            learningPathItems {
                id
                complete
                earnedMiles
                finishDatetime
                type
                miles
                icon
                url
                active
                undecided
                redo
                pathInPath { id }
                event { 
                    id 
                    eventStart 
                    eventEnd 
                }
                locked
                taskChoice { id }
                tasks { id }
                feedbackTask { id }
                grouped
                shareAnswers
            }
            customItems: learningPathItems(filter: "custom") {
                id
                earnedMiles
                complete
                icon
                url
                miles
            }
        }
    }
`);

export type ILearningPath = ResultOf<typeof query>["learningPath"];
